import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { login, loginWithLdap } from '../../api/authApi';
import { LoginDto, UserNoPassword } from 'types';
import { queryClient } from 'lib/react-query';

const nonparsedInitialUser = localStorage.getItem('user');
const initialUser: UserNoPassword | null = nonparsedInitialUser
  ? JSON.parse(nonparsedInitialUser)
  : null;

axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem(
  'token'
)}`;

interface InitialState {
  user: UserNoPassword | null;
  loginError: boolean;
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: initialUser,
    loginError: false,
  } as InitialState,

  reducers: {
    logoutSuccess: (state) => {
      state.user = null;
    },
    setUserSettings: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
        localStorage.setItem(
          'user',
          JSON.stringify({ ...state.user, ...action.payload })
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.user = action.payload;
      state.loginError = false;
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.loginError = true;
    });
    builder.addCase(loginUserWithLdap.fulfilled, (state, action) => {
      state.user = action.payload;
      state.loginError = false;
    });
    builder.addCase(loginUserWithLdap.rejected, (state, action) => {
      state.loginError = true;
    });
    builder.addCase(logout.fulfilled, (state, action) => {
      state.user = null;
    });
  },
});

export const { setUserSettings } = authSlice.actions;

export default authSlice.reducer;

export const loginUser = createAsyncThunk(
  'auth/login',
  async (loginDto: LoginDto) => {
    const { user, token } = await login(loginDto);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return user;
  }
);

export const loginUserWithLdap = createAsyncThunk(
  'auth/loginLdap',
  async (loginDto: any) => {
    const { user, token } = await loginWithLdap(loginDto);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return user;
  }
);

export const logout = createAsyncThunk('auth/logout', async () => {
  await axios.post('/api/auth/logout');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  axios.defaults.headers.common['Authorization'] = '';
  queryClient.clear();
});
